import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ProiectePushNotificationsService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private findPushNotification = this.basePath + environment.interop.monitoring.pushNotifications.find;
    private addImageUrl = this.basePath + environment.interop.monitoring.pushNotifications.view.addImage;
    private deleteImageUrl = this.basePath + environment.interop.monitoring.pushNotifications.view.deleteImage;
    private getImageUrl = this.basePath + environment.interop.monitoring.pushNotifications.view.getImage;

    constructor(private http: HttpClient) { }

    getPushNotificationById(id: number) {
        return this.http.get(this.findPushNotification + id);
    }

    sendForm(formData: FormData, id: number) {
        return this.http.post<{ data: any }>(this.addImageUrl + id, formData);
    }

    deleteImage(id: number) {
        return this.http.delete(this.deleteImageUrl + id, this.httpOptions);
    }

    getImage(id: number) {
        return this.http.get(`${this.getImageUrl}${id}`, { responseType: 'blob' });
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
